/* Business Services hero only. No network requests or retail page hooks. */
(() => {
  'use strict';
  if (window.exzohBusinessHeroReady) return;
  window.exzohBusinessHeroReady = true;
  const selector = '[data-ex-business-rotator]', instances = new Map();
  const roots = scope => scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
  function initialize(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-ex-business-slide]')].slice(0, 10);
    if (slides.length < 2) return;
    const controls = root.querySelector('[data-ex-business-controls]');
    const pause = root.querySelector('[data-ex-business-pause]');
    const count = root.querySelector('[data-ex-business-count]');
    const live = root.querySelector('[data-ex-business-live]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Math.max(3000, Math.min(15000, Number(root.dataset.interval) || 6000));
    const autoplay = root.dataset.autoplay !== 'false';
    const state = {index: 0, paused: !autoplay, hovered: false, focused: false, timer: null, listeners: []};
    const listen = (target, type, callback) => {
      if (!target) return;
      target.addEventListener(type, callback);
      state.listeners.push(() => target.removeEventListener(type, callback));
    };
    const clear = () => { if (state.timer !== null) clearTimeout(state.timer); state.timer = null; };
    function schedule() {
      clear();
      if (state.paused || state.hovered || state.focused || document.hidden || reduced.matches || !root.isConnected) return;
      state.timer = setTimeout(() => { state.timer = null; show(state.index + 1, false); schedule(); }, interval);
    }
    function show(index, announce) {
      state.index = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => slide.setAttribute('aria-hidden', String(position !== state.index)));
      if (count) count.textContent = `${state.index + 1} / ${slides.length}`;
      if (announce && live) live.textContent = `Image ${state.index + 1} of ${slides.length}`;
    }
    function updatePause() {
      if (!pause) return;
      pause.disabled = reduced.matches;
      pause.textContent = reduced.matches ? 'Slideshow paused' : state.paused ? 'Play slideshow' : 'Pause slideshow';
      pause.setAttribute('aria-label', pause.textContent);
      if (reduced.matches) pause.setAttribute('title', 'Automatic rotation is disabled while reduced motion is enabled.');
      else pause.removeAttribute('title');
    }
    listen(root.querySelector('[data-ex-business-prev]'), 'click', () => { show(state.index - 1, true); schedule(); });
    listen(root.querySelector('[data-ex-business-next]'), 'click', () => { show(state.index + 1, true); schedule(); });
    listen(pause, 'click', () => { state.paused = !state.paused; updatePause(); schedule(); });
    listen(root, 'mouseenter', () => { state.hovered = true; clear(); });
    listen(root, 'mouseleave', () => { state.hovered = false; schedule(); });
    listen(root, 'focusin', () => { state.focused = true; clear(); });
    listen(root, 'focusout', event => { if (!root.contains(event.relatedTarget)) { state.focused = false; schedule(); } });
    listen(reduced, 'change', () => { updatePause(); schedule(); });
    state.schedule = schedule;
    state.destroy = () => { clear(); state.listeners.forEach(remove => remove()); if (controls) controls.hidden = true; root.removeAttribute('data-rotator-ready'); instances.delete(root); };
    instances.set(root, state);
    root.setAttribute('data-rotator-ready', 'true');
    if (controls) controls.hidden = false;
    show(0, false); updatePause(); schedule();
  }
  const initializeWithin = scope => roots(scope).forEach(initialize);
  initializeWithin(document);
  document.addEventListener('visibilitychange', () => instances.forEach(state => state.schedule()));
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.destroy()));
})();
